export const HOST = ['https://tradeup-dev.tigerfintech.com', 'https://www.tradeup.com'];
export const API = {
    host: ''
};
